import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const RepairList = () => {

  return (
    <Table tableId="repairs" title="Repair" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="name" idKey="repair_id" fieldsToSearch={["Name", "Category"]} view={false} />
  );
};

export default RepairList;